import { Dispatch, SetStateAction } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { CustomStyle } from '../../../components/CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../components/CustomSelectStyleDarkTheme';
import FormGroup from '../../../components/FormGroup';
import MyModal from '../../../components/Modal';
import OpacityAnimation from '../../../components/OpacityAnimation';
import useThemeContext from '../../../contexts/theme';

interface IServicesModal {
  servicesModalShow: boolean;
  setServicesModalShow: Dispatch<SetStateAction<boolean>>;
  servicesList: { value: number; label: string }[];
  selectedServices: { value: number; label: string }[];
  setSelectedServices: Dispatch<SetStateAction<{ value: number; label: string }[]>>;
  confirmServices: () => Promise<void>;
}

export default function ServicesModal({
  servicesModalShow,
  setServicesModalShow,
  servicesList,
  selectedServices,
  setSelectedServices,
  confirmServices,
}: IServicesModal) {
  const { selectedTheme } = useThemeContext();
  const animatedComponents = makeAnimated();

  return (
    <>
      <MyModal
        show={servicesModalShow}
        onClose={() => setServicesModalShow(false)}
        title={'Gerenciar Serviço Habilitados'}
        modalBody={(
          <OpacityAnimation delay={0.1}>
            <FormGroup>
              <div className="title">
                  Selecione os serviços que devem ser habilitados para essa empresa.
              </div>
              <Select
                value={selectedServices}
                options={servicesList}
                onChange={(srv) => setSelectedServices(srv as { value: number; label: string }[])}
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
                isMulti
                components={animatedComponents}
                placeholder='Selecione os serviços'
              />
            </FormGroup>
          </OpacityAnimation>
        )}
        closeButtonLabel="Fechar"
        size="lg"
        type='action'
        actionButtonLabel="Adicionar"
        onAction={() => confirmServices()}
        minHeight='400px'

      />
    </>
  );
}
